export default "__VITE_ASSET__DCOrROUX__"